module.exports = __webpack_public_path__ + "img/back2.7c4833bb.jpg";